import React, {useEffect, useState} from 'react';

//Material
import {
  Autocomplete,
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import {emailRegExp, telegramRegExp} from '../../services/regularExp';
import {Form, FormikProvider, useFormik} from 'formik';
import * as Yup from 'yup';
import styled from '@emotion/styled';
import './ContactModal.css';
import {useTranslate} from 'react-redux-multilingual';
import {useSnackbar} from 'notistack';
import {StyledLabel} from '../../components/StyledComponents';
import ApiService from '../../helpers/apiHelper';
import {LoadingButton} from '@mui/lab';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: 800,
  minHeight: 500,
  height: 'inherit',
  maxHeight: { xs: '100vh', sm: '95vh' },
  bgcolor: 'background.paper',
  borderRadius: '20px',
  border: '1px solid #0D7834',
  boxShadow: 24,
  p: 4,
  overflowY: 'scroll',
  overflowX: 'hidden',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};
const StyledButton = styled(LoadingButton)(({ theme }) => ({
  
  color: theme.palette.common.white,
  fontFamily: 'Noto Sans',
  textTransform: 'uppercase',
  borderRadius: '50px',
  maxWidth: 'fit-content',
  minWidth: '150px',
  padding: '0 20px',
  '&:hover': { backgroundColor: 'transparent' },
  boxShadow: '0px 7px 10px 1px rgb(145 158 171 / 30%)',
  background:
    'linear-gradient(353.54deg, #043B1F 3.03%, #0D7834 37.41%, #0E8D3D 67.77%, #0B9552 104.82%)'
}));
const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#0d7834',
   whiteSpace:'normal',
   
  },
  '& label': {
    color: '#0d7834',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
  },
  '& .MuiInput-underline:after': {
    border: '1px #0d7834 solid'
  },
  '& .MuiInputBase-root:before': {
    borderBottom: '1px #0d7834 solid'
  },

  '& .MuiInput-root:hover:not(Mui-disabled):before': {
    borderBottom: '2px #0d7834 solid'
  },
  '& .MuiInput-root': {
    marginTop: '0'
  },
  '& .MuiInputLabel-root': {
    top: '-10px',
    fontSize: window.screen.width <= 600 && '14px'
  }
});
const CssTextFieldA = styled(TextField)({
  '& label.Mui-focused': {
    color: '#0d7834',
   whiteSpace:'normal',
    top:'-25px'
   
  },
  '& label': {
    color: '#0d7834',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
  },
  '& .MuiInput-underline:after': {
    border: '1px #0d7834 solid'
  },
  '& .MuiInputBase-root:before': {
    borderBottom: '1px #0d7834 solid'
  },

  '& .MuiInput-root:hover:not(Mui-disabled):before': {
    borderBottom: '2px #0d7834 solid'
  },
  '& .MuiInput-root': {
    marginTop: '0'
  },
  '& .MuiInputLabel-root': {
    top: '-10px',
    fontSize: window.screen.width <= 600 && '14px'
  }
});

export default function ContactModal({ isOpenModal, setIsOpenModal, onSubmit }) {
  const [contactType, setContactType] = useState('email');
  const [isLoading, setIsLoading] = useState(false);
  const [screenType, setScreenType] = useState('desktop');
  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);

  const translate = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const api = new ApiService('send-message', translate);
  const schema = Yup.object()
    .shape({
      name: Yup.string()
        .min(2, translate('error_input_lenght_min_2'))
        .max(255, translate('error_input_lenght_max_255'))
        .required(translate('error_required')),
      subject: Yup.string()
        .min(2, translate('error_input_lenght_min_2'))
        .max(255, translate('error_input_lenght_max_255'))
        .required(translate('error_required')),

      message: Yup.string()
        .min(10, translate('error_input_lenght_min_10'))
        .max(255, translate('error_input_lenght_max_255'))
        .required(translate('error_required')),
      businessQ : Yup.string(translate('error_required')).nullable().oneOf([translate('visitCard_contact_modal_q_1_1'),translate('visitCard_contact_modal_q_1_2'),translate('visitCard_contact_modal_q_1_3'),translate('visitCard_contact_modal_q_1_4')]).required(translate('error_required')),
      devopsQ : Yup.string(translate('error_required')).nullable().oneOf([translate('visitCard_contact_modal_q_2_1'),translate('visitCard_contact_modal_q_2_2'),translate('visitCard_contact_modal_q_2_3'),translate('visitCard_contact_modal_q_2_4')]).required(translate('error_required')),
      problemQ : Yup.string(translate('error_required')).nullable().oneOf([translate('visitCard_contact_modal_q_3_1'),translate('visitCard_contact_modal_q_3_2'),translate('visitCard_contact_modal_q_3_3'),translate('visitCard_contact_modal_q_3_4'),translate('visitCard_contact_modal_q_3_5'),translate('visitCard_contact_modal_q_3_6')]).required(translate('error_required')),
      infrastructureQ : Yup.string(translate('error_required')).nullable().oneOf([translate('visitCard_contact_modal_q_4_1'),translate('visitCard_contact_modal_q_4_2'),translate('visitCard_contact_modal_q_4_3'),translate('visitCard_contact_modal_q_4_4')]).required(translate('error_required')),
      budgetQ : Yup.string(translate('error_required')).nullable().oneOf([translate('visitCard_contact_modal_q_5_1'),translate('visitCard_contact_modal_q_5_2'),translate('visitCard_contact_modal_q_5_3'),translate('visitCard_contact_modal_q_5_4'),translate('visitCard_contact_modal_q_5_5')]).required(translate('error_required'))
    })
    .when((values, schema) => {
      if (contactType === 'email') {
        return schema.shape({
          contact: Yup.string()
            .matches(emailRegExp, translate('error_regExp_email'))
            .required(translate('error_required'))
        });
      }
      return schema.shape({
        contact: Yup.string()
          .matches(telegramRegExp, translate('error_regExp_telegram'))
          .required(translate('error_required'))
      });
    }).when((values, schema) => {
      if(values?.businessQ==='Інше'||values?.businessQ==='Other'){
        return schema.shape({
          businessQOther: Yup.string()
              .min(2, translate('error_input_lenght_min_2'))
              .max(255, translate('error_input_lenght_max_255'))
              .required(translate('error_required')),
        })
      }
      
      }).when((values, schema) => { 
        if(values?.devopsQ==='Інше'||values?.devopsQ==='Other'){
        return schema.shape({
          devopsQOther: Yup.string()
              .min(2, translate('error_input_lenght_min_2'))
              .max(255, translate('error_input_lenght_max_255'))
              .required(translate('error_required')),
        })
      } }).when((values, schema) => {
        if(values?.problemQ==='Інше'||values?.problemQ==='Other'){
          return schema.shape({
            problemQOther: Yup.string()
                .min(2, translate('error_input_lenght_min_2'))
                .max(255, translate('error_input_lenght_max_255'))
                .required(translate('error_required')),
          })
        }
      })
  const formik = useFormik({
    initialValues: {
      name: '',
      subject: '',
      contact: '',
      message: '',
      businessQ: '',
      businessQOther:'',
      devopsQ: '',
      devopsQOther:'',
      problemQ: '',
      problemQOther:'',
      infrastructureQ: '',
      budgetQ: '',
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: (values, { resetForm, setErrors }) => {
      setIsLoading(true);
      const newData = {
        name: values.name,
        subject: values.subject,
        contact: values.contact,
        typeOfBusiness: `${values?.businessQ}${values?.businessQ==='Інше'||values?.businessQ==="Other"?': '+values?.businessQOther:''}`,
        usingDevOps: `${values?.devopsQ}${values?.devopsQ==='Інше'||values?.devopsQ==="Other"?': '+values?.devopsQOther:''}`,
        typeOfProblem: `${values?.problemQ}${values?.problemQ==='Інше'||values?.problemQ==="Other"?': '+values?.problemQOther:''}`,
        sizeOfInfrastructure: `${values?.infrastructureQ}`,
        budget: `${values?.budgetQ}`,
        message: values.message
      };
      api
        .sendRequest(newData)
        .then((res) => {
          enqueueSnackbar(translate('success_sending_contacts'), { variant: 'success' });
          setTimeout(() => {
            window?.dataLayer.push({'event':'form_submit'})
            setIsLoading(false);
            resetForm();
            setIsOpenModal(false);
          }, 1000);
        })
        .catch((error) => {
          enqueueSnackbar(translate('error_sending_contacts'), { variant: 'error' });
          setIsLoading(false);
          setErrors(error);
        });
    }
  });
  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    setFieldValue,
    submitForm,
    resetForm
  } = formik;
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={() => {
          setIsOpenModal(false);
          resetForm();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="visitCard_contact_modal"
      >
        <Box sx={style} className="visitCard_contact_modal-box">
          <CloseIcon
            className="visitCard_contact_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              setIsOpenModal(false);
              resetForm();
            }}
          />
          <div>
            <FormikProvider value={formik}>
              <Form
                autoComplete="off"
                noValidate
                onSubmit={handleSubmit}
                style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
              >
                <Grid container spacing={screenType !== 'desktop' ? 1 : 2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <StyledLabel className="contactModal-title-text">
                      {translate('visitCard_contact_modal')}
                    </StyledLabel>
                    <Typography className="contactModal-main-text" style={{ marginBottom: '30px', textAlign:'center' }}>
                      {translate('visitCard_contact_modal_l')}
                    </Typography>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    
                    <FormControl>
                      <FormLabel
                        id="demo-controlled-radio-buttons-group"
                        style={{ color: 'black', marginBottom: '10px', fontFamily: 'Noto Sans' }}
                      >
                        {translate('visitCard_contact_modal_inputType')}
                      </FormLabel>
                      <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={contactType}
                        onChange={(e) => {
                          if (e.target.value === 'email') {
                            setFieldValue('contact', '');
                          } else {
                            setFieldValue('contact', '');
                          }
                          setContactType(e.target.value);
                        }}
                      >
                        <FormControlLabel
                          value="email"
                          control={<Radio style={{ color: '#0d7834' }} />}
                          label={translate('visitCard_contact_modal_inputType_email')}
                        />
                        <FormControlLabel
                          value="telegram"
                          control={<Radio style={{ color: '#0d7834' }} />}
                          label={translate('visitCard_contact_modal_inputType_telegram')}
                        />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <Grid item xs={12} className="contactModal-inputs-first">
                      <CssTextField
                        label={translate('visitCard_contact_modal_input_name')}
                        variant="standard"
                        fullWidth
                        size="normal"
                        inputProps={{ style: { textAlign: 'center' } }}
                        error={Boolean(touched.name && errors.name)}
                        {...getFieldProps('name')}
                        value={values.name}
                      >
                        {values.name}
                      </CssTextField>
                      {touched.name && errors.name && (
                        <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                          {errors.name}
                        </div>
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <CssTextField
                        color="grey"
                        fullWidth
                        size="normal"
                        inputProps={{ style: { textAlign: 'center' } }}
                        error={Boolean(touched.subject && errors.subject)}
                        {...getFieldProps('subject')}
                        value={values.subject}
                        label={translate('visitCard_contact_modal_input_subject')}
                        variant="standard"
                      >
                        {values.subject}
                      </CssTextField>
                      {touched.subject && errors.subject && (
                        <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                          {errors.subject}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <CssTextField
                        color="grey"
                        fullWidth
                        size="normal"
                        inputProps={{ style: { textAlign: 'center' } }}
                        error={Boolean(touched.contact && errors.contact)}
                        {...getFieldProps('contact')}
                        value={values.contact}
                        label={
                          contactType === 'email'
                            ? translate('visitCard_contact_modal_input_email')
                            : translate('visitCard_contact_modal_input_telegram')
                        }
                        variant="standard"
                      >
                        {values.contact}
                      </CssTextField>
                      {touched.contact && errors.contact && (
                        <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                          {errors.contact}
                        </div>
                      )}
                    </Grid>

                    <Grid item xs={12} style={{ marginBottom: '20px' }}>
                      <CssTextField
                        color="grey"
                        fullWidth
                        size="normal"
                        inputProps={{ style: { textAlign: 'center' } }}
                        error={Boolean(touched.message && errors.message)}
                        {...getFieldProps('message')}
                        value={values.message}
                        label={translate('visitCard_contact_modal_input_message')}
                        variant="standard"
                      >
                        {values.message}
                      </CssTextField>
                      {touched.message && errors.message && (
                        <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                          {errors.message}
                        </div>
                      )}
                    </Grid>
                    
                  </Grid>
                  <Grid item xs={12}>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <label htmlFor="visitCard_businessQ" style={touched.businessQ && errors.businessQ?{color:'red', fontSize:"14px"}:{color:'#0d7834', fontSize:"14px"}}>{translate("visitCard_contact_modal_qLabel_1")}</label>
                      <Autocomplete
                          id="visitCard_businessQ"
                          value={values.businessQ}
                          onChange={(event, value) => {
                            setFieldValue('businessQ', value)
                            setFieldValue('businessQOther', '')
                          }}
                          disablePortal
                          options={[translate("visitCard_contact_modal_q_1_1"),translate("visitCard_contact_modal_q_1_2"),translate("visitCard_contact_modal_q_1_3"),translate("visitCard_contact_modal_q_1_4")]}
                          // sx={{ width: 300 }}
                          renderInput={(params) => <><CssTextFieldA name="visitCard_businessQ" placeholder={translate("visitCard_contact_modal_select_placeholder")} variant="standard" {...params}  /></>}
                      />
                      {values?.businessQ==='Інше'||values?.businessQ==="Other" ? (
                          <>
                            <CssTextField
                                sx={{ marginTop: '10px'}}
                              color="grey"
                              fullWidth
                              size="normal"
                              inputProps={{ style: { textAlign: 'center' } }}
                              error={Boolean(touched.businessQOther && errors.businessQOther)}
                              {...getFieldProps('businessQOther')}
                              value={values.businessQOther}
                              label={translate('visitCard_contact_modal_qLabel_all')}
                              variant="standard"
                          >
                            {values.businessQOther}
                          </CssTextField>
                            {touched.businessQOther && errors.businessQOther && (
                                <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                                  {errors.businessQOther}
                                </div>
                            )}
                          </>
                          
                          
                      ):null}
                      {touched.businessQ && errors.businessQ && (
                          <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                            {errors.businessQ}
                          </div>
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <label htmlFor="visitCard_devopsQ" style={touched.devopsQ && errors.devopsQ?{color:'red', fontSize:"14px"}:{color:'#0d7834', fontSize:"14px"}}>{translate("visitCard_contact_modal_qLabel_2")}</label>
                      <Autocomplete
                          id="visitCard_devopsQ"
                          value={values.devopsQ}
                          onChange={(event, value) => {
                            setFieldValue('devopsQ', value)
                            setFieldValue('devopsQOther', '')
                          }}
                          disablePortal
                          options={[translate("visitCard_contact_modal_q_2_1"),translate("visitCard_contact_modal_q_2_2"),translate("visitCard_contact_modal_q_2_3"),translate("visitCard_contact_modal_q_2_4")]}
                          // sx={{ width: 300 }}
                          renderInput={(params) => <><CssTextFieldA  name="visitCard_devopsQ" placeholder={translate("visitCard_contact_modal_select_placeholder")} variant="standard" {...params}  /></>}
                      />
                      {values?.devopsQ==='Інше'||values?.devopsQ==="Other" ? (
                          <>
                            <CssTextField
                                sx={{ marginTop: '10px'}}
                                color="grey"
                                fullWidth
                                size="normal"
                                inputProps={{ style: { textAlign: 'center' } }}
                                error={Boolean(touched.devopsQOther && errors.devopsQOther)}
                                {...getFieldProps('devopsQOther')}
                                value={values.devopsQOther}
                                label={translate('visitCard_contact_modal_qLabel_all')}
                                variant="standard"
                            >
                              {values.devopsQOther}
                            </CssTextField>
                            {touched.devopsQOther && errors.devopsQOther && (
                                <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                                  {errors.devopsQOther}
                                </div>
                            )}
                          </>


                      ):null}
                      {touched.devopsQ && errors.devopsQ && (
                          <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                            {errors.devopsQ}
                          </div>
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <label htmlFor="visitCard_problemQ" style={touched.problemQ && errors.problemQ?{color:'red', fontSize:"14px"}:{color:'#0d7834', fontSize:"14px"}}>{translate("visitCard_contact_modal_qLabel_3")}</label>
                        <Autocomplete 
                          id={"visitCard_problemQ"}
                          value={values.problemQ}
                          onChange={(event, value) => {
                            setFieldValue('problemQ', value)
                            setFieldValue('problemQOther', '')
                          }}
                          disablePortal
                          options={[translate("visitCard_contact_modal_q_3_1"),translate("visitCard_contact_modal_q_3_2"),translate("visitCard_contact_modal_q_3_3"),translate("visitCard_contact_modal_q_3_4"),translate("visitCard_contact_modal_q_3_5"),translate("visitCard_contact_modal_q_3_6")]}
                          // sx={{ width: 300 }}
                          renderInput={(params) =><><CssTextFieldA  name={"visitCard_problemQ"} placeholder={translate("visitCard_contact_modal_select_placeholder")} variant="standard" {...params}  /></>}
                      />
                      {values?.problemQ==='Інше'||values?.problemQ==="Other" ? (
                          <>
                            <CssTextField
                                sx={{ marginTop: '10px'}}
                                color="grey"
                                fullWidth
                                size="normal"
                                inputProps={{ style: { textAlign: 'center' } }}
                                error={Boolean(touched.problemQOther && errors.problemQOther)}
                                {...getFieldProps('problemQOther')}
                                value={values.problemQOther}
                                label={translate('visitCard_contact_modal_qLabel_all')}
                                variant="standard"
                            >
                              {values.problemQOther}
                            </CssTextField>
                            {touched.problemQOther && errors.problemQOther && (
                                <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                                  {errors.problemQOther}
                                </div>
                            )}
                          </>


                      ):null}
                      {touched.problemQ && errors.problemQ && (
                          <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                            {errors.problemQ}
                          </div>
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <label htmlFor="visitCard_infrastructureQ" style={touched.infrastructureQ && errors.infrastructureQ?{color:'red', fontSize:"14px"}:{color:'#0d7834', fontSize:"14px"}}>{translate("visitCard_contact_modal_qLabel_4")}</label>
                      <Autocomplete
                          id={"visitCard_infrastructureQ"}
                          value={values.infrastructureQ}
                          onChange={(event, value) => {
                            setFieldValue('infrastructureQ', value)
                          }}
                          disablePortal
                          options={[translate("visitCard_contact_modal_q_4_1"),translate("visitCard_contact_modal_q_4_2"),translate("visitCard_contact_modal_q_4_3"),translate("visitCard_contact_modal_q_4_4")]}
                          // sx={{ width: 300 }}
                          renderInput={(params) => <><CssTextFieldA  name={"visitCard_infrastructureQ"} placeholder={translate("visitCard_contact_modal_select_placeholder")} variant="standard" {...params}/></>}
                      />
                    
                      {touched.infrastructureQ && errors.infrastructureQ && (
                          <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                            {errors.infrastructureQ}
                          </div>
                      )}
                    </Grid>
                    <Grid item xs={12} style={{ marginBottom: '10px' }}>
                      <label htmlFor="visitCard_budgetQ" style={touched.budgetQ && errors.budgetQ?{color:'red', fontSize:"14px"}:{color:'#0d7834', fontSize:"14px"}}>{translate("visitCard_contact_modal_qLabel_5")}</label>
                        <Autocomplete
                            id={"visitCard_budgetQ"}
                        value={values.budgetQ}
                        onChange={(event, value) => {
                          setFieldValue('budgetQ', value)
                        }}
                        disablePortal
                        options={[translate('visitCard_contact_modal_q_5_1'),translate('visitCard_contact_modal_q_5_2'),translate('visitCard_contact_modal_q_5_3'),translate('visitCard_contact_modal_q_5_4'),translate('visitCard_contact_modal_q_5_5')]}
                        // sx={{ width: 300 }}
                        renderInput={(params) =><><CssTextFieldA  name={"visitCard_budgetQ"} placeholder={translate("visitCard_contact_modal_select_placeholder")} variant="standard" {...params}  /></>}
                    />
                     
                    {touched.budgetQ && errors.budgetQ && (
                        <div style={{ color: 'red', margin: '5px 0px', fontSize: '12px' }}>
                          {errors.budgetQ}
                        </div>
                    )}
                  </Grid>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}
                  >
                    <StyledButton size="large" onClick={submitForm} loading={isLoading}>
                      {translate('visitCard_contact_modal_button_send')}
                    </StyledButton>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
